"use strict";

exports.__esModule = true;
exports.openHtmlLayoutRight = exports.openHtmlLayoutLeft = exports.openHtmlLayoutFullWide = exports.openHtmlBaseStyles = exports.openHtmlBaseLayout = void 0;

var _styledComponents = require("styled-components");

var _utils = require("./utils");

var _mediaQueries = _interopRequireDefault(require("./media-queries"));

var _system = require("./system");

var _lists = _interopRequireDefault(require("./lists"));

var _typography = require("./typography");

var _colors = require("./colors");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var formatWysiwygColors = function formatWysiwygColors() {
  return Object.keys(_colors.wysiwygColors).map(function (color) {
    return (0, _styledComponents.css)([".", " a:hover{border-bottom-color:", ";color:", ";}"], color, _colors.wysiwygColors[color], _colors.wysiwygColors[color]);
  });
};

var openHtmlBaseLayout = function openHtmlBaseLayout() {
  return (0, _styledComponents.css)(["", " ", " ", ";"], _mediaQueries["default"].lap(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      margin-left:", "%;\n      width:", "%;\n      padding-left: 10px;\n      padding-right: 10px;\n    "])), 1 / 12 * 100, 10 / 12 * 100), _mediaQueries["default"].desk(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      margin-left:", "%;\n      width:", "%;\n    "])), 2 / 12 * 100, 8 / 12 * 100), _mediaQueries["default"].deskWide(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      width:", "%;\n    "])), 7 / 12 * 100));
};

exports.openHtmlBaseLayout = openHtmlBaseLayout;

var openHtmlLayoutLeft = function openHtmlLayoutLeft() {
  return (0, _styledComponents.css)(["float:left;margin-right:1em;", ";"], _mediaQueries["default"].lap(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      margin-left: ", "%;\n    "])), 1 / 12 * 100));
};

exports.openHtmlLayoutLeft = openHtmlLayoutLeft;

var openHtmlLayoutRight = function openHtmlLayoutRight() {
  return (0, _styledComponents.css)(["float:right;margin-left:1em;", ";"], _mediaQueries["default"].lap(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      margin-right:", "%;\n  "])), 1 / 12 * 100));
};

exports.openHtmlLayoutRight = openHtmlLayoutRight;

var openHtmlLayoutFullWide = function openHtmlLayoutFullWide() {
  return (0, _styledComponents.css)(["margin-left:", "%;width:", "%;"], 1 / 12 * 100, 10 / 12 * 100);
};

exports.openHtmlLayoutFullWide = openHtmlLayoutFullWide;

var openHtmlBaseStyles = function openHtmlBaseStyles() {
  return (0, _styledComponents.css)(["", ";", ";a{", ";color:currentColor;text-decoration:none;}em{font-style:italic;}strong{font-weight:700;}sub{bottom:-0.25em;font-size:80%;font-weight:400;position:relative;vertical-align:sub;}sup{font-size:50%;vertical-align:super;font-weight:400;position:relative;top:-0.6em;}ul,ol{list-style:none;ul,ol,p{margin-left:0;width:auto;}ul,ol{margin-bottom:0;}}p,ol,ul{margin-top:0;margin-bottom:0;}iframe,img,video{max-width:100%;display:block;}h1,h2,h3,h4,h5,h6{color:", ";margin-bottom:0.4em;margin-top:1em;}h1{", ";margin-top:0.7em;}h2{", ";margin-top:1.3em;}h3{", ";}h4{", ";}h5{", ";color:", ";}h6{", ";color:", ";}hr{background:", ";border:none;clear:both;height:2px;margin-top:40px;margin-bottom:40px;margin-left:calc(33.33333% + 10px);margin-right:calc(33.33333% + 10px);", ":first-child >:first-child{margin-top:0;}:last-child >:last-child{margin-bottom:0;}}"], formatWysiwygColors(), (0, _lists["default"])(), (0, _utils.transitionEase)("0.2s", ["color", "border-color"]), (0, _system.colors)("gray-dark"), (0, _typography.typeXLarge)(600), (0, _typography.typeLarge)(600), (0, _typography.typeNormal)(600), (0, _typography.typeXSmall)(600), (0, _typography.typeSmall)(600), (0, _system.colors)("gray-menu"), (0, _typography.typeBody)(400), (0, _system.colors)("gray-menu"), (0, _system.colors)("gray-divider"), _mediaQueries["default"].lap(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      margin-top: 80px;\n      margin-bottom: 80px;\n    "]))));
};

exports.openHtmlBaseStyles = openHtmlBaseStyles;